import { Component, OnInit } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-modal-wizard',
  templateUrl: './modal-wizard.component.html',
  styleUrls: ['./modal-wizard.component.scss']
})
export class ModalWizardComponent implements OnInit {
  NomostrarMo:any;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
  public dialogRef: MatDialogRef<ModalWizardComponent>,) {
      lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });}

  ngOnInit(

  ): void {

  }
  salir(dato?:any){
    this.dialogRef.close(dato);
  }
}
